var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _c('div', {
    staticClass: "tag-list"
  }, _vm._l(_vm.controls, function (control) {
    return _c('div', {
      key: control[_vm.valueKey],
      staticClass: "tag-item",
      class: _vm.itemClass(control),
      on: {
        "click": function ($event) {
          return _vm.select(control);
        }
      }
    }, [_vm._v(" " + _vm._s(control[_vm.labelKey]) + " ")]);
  }), 0);
};

var staticRenderFns = [];
export { render, staticRenderFns };